import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-chart",
  "use": "icon-chart-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"#BFCBD9\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"lucide lucide-file-bar-chart-2\" id=\"icon-chart\"><path d=\"M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z\" /><polyline points=\"14 2 14 8 20 8\" /><path d=\"M12 18v-6\" /><path d=\"M8 18v-1\" /><path d=\"M16 18v-3\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol